module.exports = __webpack_public_path__ + "static/media/004.70787dd2.jpg";